import React from "react";

import { SkeletonBlock } from "../primitives";
import TableRowSkeleton from "./TableRowSkeleton";

/**
 * Full table skeleton — header bar + N rows.
 *
 * @param {number} rows     — Number of skeleton rows (default: 5)
 * @param {Array}  columns  — Column config array, forwarded to TableRowSkeleton
 * @param {boolean} showHeader — Show header row placeholder (default: true)
 * @param {string}  className
 */
const TableSkeleton = ({
  rows = 5,
  columns,
  showHeader = true,
  className = "",
}) => {
  return (
    <div className={className} style={{ width: "100%" }}>
      {/* Table header placeholder */}
      {showHeader && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "14px 16px",
            borderBottom: "2px solid #f0f0f0",
          }}
        >
          {(columns || []).map((col, i) => (
            <div
              key={i}
              style={{
                width: col.width || "auto",
                flexShrink: 0,
                flexGrow: col.grow !== undefined ? col.grow : col.width ? 0 : 1,
                minWidth: col.minWidth || "100px",
                padding: "0 8px",
              }}
            >
              <SkeletonBlock width="60%" height={12} radius="sm" />
            </div>
          ))}
        </div>
      )}

      {/* Data rows */}
      {Array.from({ length: rows }).map((_, i) => (
        <TableRowSkeleton key={i} columns={columns} />
      ))}
    </div>
  );
};

export default TableSkeleton;
